<nz-divider
    class="no-margin"
    nzPlain="true"
    [nzText]="text"
    nzOrientation="left"
>
    <ng-template #text>
        <div class="sider-divider-text">
            {{ datasourceColumnName }}
        </div>
    </ng-template>
</nz-divider>
<div class="segment-container">
    <div class="segment-select-and-buttons">
        <nz-select
            [nzMaxTagCount]="3"
            [nzMaxTagPlaceholder]="tagPlaceHolder"
            nzMode="multiple"
            [nzPlaceHolder]="'Select segments'"
            [(ngModel)]="selectedOptionsViewModel"
            (nzOpenChange)="onAttributeDropdownToggle($event)"
            (ngModelChange)="onModelChange($event)"
            [nzDropdownMatchSelectWidth]="false"
            [nzDropdownStyle]="{ 'font-size': '12px' }"
            [nzAllowClear]="true"
            nzAutoClearSearchValue="false"
            [nzBorderless]="false"
            [nzShowArrow]="true"
            [nzLoading]="dataLoaderResult.isLoading"
            [nzOptionOverflowSize]="19"
            [nzOptionHeightPx]="25"
            nzSize="small"
        >
            <nz-option
                *ngFor="let item of availableOptions"
                [nzLabel]="item"
                [nzValue]="item"
            ></nz-option>
        </nz-select>
        <ng-template #tagPlaceHolder let-selectedList
            >and {{ selectedList.length }} more selected</ng-template
        >
        <div class="excl-split-checkboxes">
            <label
                *ngIf="enableExcludeMode"
                nz-checkbox
                [(ngModel)]="selectedExcludeModeViewModel"
                (ngModelChange)="onExcludeModeChange($event)"
                >Excl</label
            >
            <label
                *ngIf="!enableExcludeMode"
                style="visibility: hidden"
                nz-checkbox
                >Excl</label
            >

            <label
                *ngIf="enableSplitMode"
                style="margin-left: 0px"
                nz-checkbox
                [(ngModel)]="selectedSplitViewModel"
                (ngModelChange)="onSplitSelectionChange($event)"
                [nzDisabled]="isSplitControlDisabled"
                [nz-tooltip]="
                    isSplitControlDisabled
                        ? 'Select segments to enable split'
                        : null
                "
                >Split</label
            >
        </div>
    </div>
    <div style="display: flex">
        <div class="segment-operator">
            <div>
                <nz-radio-group
                    [(ngModel)]="selectedOperatorViewModel"
                    (ngModelChange)="onOperatorSelectionChange($event)"
                    nzSize="small"
                    nzButtonStyle="solid"
                >
                    <label nz-radio-button nzValue="OR">OR</label>
                    <label nz-radio-button nzValue="AND">AND</label>
                </nz-radio-group>
            </div>
        </div>
        <div style="flex: 1"></div>
        <div *ngIf="dashboardItem.showNewSegmentLink">
            <a [href]="config.newSegmentWikiLink" target="_blank"
                >New Segment?</a
            >
        </div>
    </div>
    <app-upflit-reference-segment-selector
        *ngIf="dashboardItem.upliftReferenceSegmentSettingId"
        [upliftReferenceSegmentSettingId]="
            dashboardItem.upliftReferenceSegmentSettingId
        "
        [availableSegments]="selectedOptionsViewModel"
        [disableSegmentSelection]="
            !selectedSplitViewModel || isSplitControlDisabled
        "
    ></app-upflit-reference-segment-selector>
</div>
